module.exports = __webpack_public_path__ + "static/media/_question.14360c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_question.jpg
// module id = 60
// module chunks = 0